export const FEE_RATE = 0.1325;
export const FEE_FIXED = 0.3;

export const netAfterFees = (price) => Math.max(0, Number(price || 0) * (1 - FEE_RATE) - FEE_FIXED);

// Spread what was paid for the haul across the items being listed, in proportion to their value.
export function allocateHaulCost(paid, keepers, created) {
  const total = Number(paid);
  if (paid === "" || paid == null || !(total >= 0) || !created.length) return [];
  if (total === 0) return created.map((c) => ({ id: c.draft_id, item_cost: "0.00" })); // got it free
  const byRun = Object.fromEntries(keepers.map((k) => [k.run.id, Number(k.run.suggested_price || 0)]));
  const made = created.filter((c) => byRun[c.run_id] != null);
  const sum = keepers.reduce((a, k) => a + Number(k.run.suggested_price || 0), 0) || 1;
  return made.map((c) => ({ id: c.draft_id, item_cost: (total * (byRun[c.run_id] / sum)).toFixed(2) }));
}

// Split a total across items by their value (evenly if none have a value); cents add up exactly.
export function splitByValue(paid, items) {
  const total = Math.round(Number(paid) * 100);
  if (!(total > 0) || !items.length) return [];
  const vals = items.map((i) => Math.max(0, Number(i.value) || 0));
  const sum = vals.reduce((a, v) => a + v, 0);
  const weights = sum ? vals.map((v) => v / sum) : items.map(() => 1 / items.length);
  let left = total;
  return items.map((it, k) => {
    const cents = k === items.length - 1 ? left : Math.round(total * weights[k]);
    left -= cents;
    return { id: it.id, item_cost: (cents / 100).toFixed(2) };
  });
}
